import { persist } from "zustand/middleware";
import create from "zustand";

type OnBoardingState = {
  lastRun: number;
  shouldRun: string[];
  skipped: boolean;
  addShouldRun: (ids: string[]) => void;
  setShouldRun: (ids: string[]) => void;
  removeShouldRun: (id: string) => void;
  setSkipped: (skip: boolean) => void;
  setLastRun: (timestamp: number) => void;
};

const useOnboardingStore = create<OnBoardingState>()(
  persist(
    (set) => ({
      lastRun: 0,
      shouldRun: [] as string[],
      skipped: false,
      addShouldRun: (ids) =>
        set((state) => ({
          shouldRun: [...state.shouldRun, ...ids].reduce(
            (prev, cur) => (prev.includes(cur) ? prev : [...prev, cur]),
            [] as string[]
          ),
        })),
      setShouldRun: (ids) =>
        set((state) => ({
          shouldRun: ids,
        })),
      removeShouldRun: (id) =>
        set((state) => {
          const idx = state.shouldRun.findIndex((item) => item === id);
          let newShouldRun = [...state.shouldRun];
          if (idx !== -1) {
            newShouldRun.splice(idx, 1);
          }
          return {
            shouldRun: newShouldRun,
          };
        }),
      setSkipped: (skipped) =>
        set(() => ({
          skipped: skipped,
        })),
      setLastRun: (timestamp: number) =>
        set(() => ({
          lastRun: timestamp,
        })),
    }),
    {
      name: "onboarding",
      getStorage: () => localStorage,
    }
  )
);

export const useOnboardingState = (id: string) => {
  return useOnboardingStore((state) => ({
    shouldRun: state.shouldRun.includes(id),
  }));
};

export const useOnboarding = () => {
  return useOnboardingStore((state) => ({
    lastRun: state.lastRun,
    shouldRun: state.shouldRun,
    skipped: state.skipped,
    setShouldRun: state.setShouldRun,
    removeShouldRun: state.removeShouldRun,
    setLastRun: state.setLastRun,
    setSkipped: state.setSkipped,
  }));
};
